import HelpMenu from './HelpMenu.jsx';
import NavBar from '@apps-common/ui-components/NavBar';
import OrgSwitcher from '../OrgSwitcher.jsx';
import PropTypes from 'prop-types';
import React from 'react';
import ThemeMenu from './ThemeMenu.jsx';
import {API_TARGET} from '@app/config';
import {Chip, Tooltip} from '@mui/material';
import {capitalize} from '@mui/material/utils';
import {isAdmin} from '@app/util/user';
import {reset as resetAnalytics, trackEvent} from '@app/analytics';
import {useAuth} from '@apps-common/auth-react';
import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {withDarkTheme} from '@app/styles';

const APITargetChip = () => {
  if (window.location.hostname === 'www.planet.com') {
    return false;
  }
  const prefix = import.meta.env.DEV ? 'Local' : 'Internal';
  const tooltipText = `Granero: ${import.meta.env.VITE_GRANERO_TARGET}`;
  return (
    <Tooltip title={tooltipText}>
      <Chip
        label={`${prefix} - ${capitalize(API_TARGET)}`}
        color={import.meta.env.DEV ? 'info' : 'secondary'}
        sx={{marginRight: 1}}
      />
    </Tooltip>
  );
};

const TopNavBar = ({themeSwitch, setThemeSwitch}) => {
  const themeModeLabOn = useSelector(state => state.labs.themeMode);
  const {t} = useTranslation();
  const auth = useAuth();

  const logout = () => {
    trackEvent('Logout Button clicked');

    resetAnalytics();

    auth.signOut();
  };

  return (
    <NavBar
      title={t('global.productName')}
      titleChipProps={
        isAdmin(auth.user.claims)
          ? {
              label: 'ADMIN',
              sx: {
                fontWeight: 500,
                backgroundColor: 'grey.500',
              },
            }
          : null
      }
      user={auth.user?.claims}
      primary={auth.user && <OrgSwitcher />}
      secondary={
        <>
          <APITargetChip />

          {themeModeLabOn && (
            <ThemeMenu
              themeSwitch={themeSwitch}
              setThemeSwitch={setThemeSwitch}
            />
          )}
          <HelpMenu />
        </>
      }
      logout={logout}
      sx={{zIndex: 'modal', boxShadow: 'none'}}
      elevation={0}
    />
  );
};

TopNavBar.propTypes = {
  themeSwitch: PropTypes.string,
  setThemeSwitch: PropTypes.func,
};

export default withDarkTheme(TopNavBar);
